import { FC } from "react";
import { StaticImage } from "../StaticImage";
import { useStyles } from "./VoucherInventoryDetail.style";
import { TypographyVariant } from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import {
  EpayInventoryCost,
  Inventory,
  InventoryAvatarData,
  InventoryEpayItemData,
} from "@onmo/graphql/graphql";
import { ItemCurrencySymbol } from "../../../constants/voucher";

export const Voucheritem: FC<{ item: Inventory; onClick?: () => void }> = ({
  item,
  onClick,
}) => {
  const classes = useStyles();
  const currency = (item.prices?.[0] as EpayInventoryCost)?.currency;
  return (
    <div
      key={item.id}
      className={classes.itemWrapper}
      onClick={onClick}
    >
      <StaticImage
        src={(item.data as InventoryAvatarData).url}
        className={classes.voucherIconWrapper}
      />
      <div className={classes.infoWrapper}>
        <Typography
          variant={TypographyVariant.BodyB5Medium}
        >
          {item.title}
        </Typography>
        {item.prices && item.prices.length > 0 && (
          <Typography
            variant={TypographyVariant.BodyB4Medium}
            className={classes.price}
          >
            {ItemCurrencySymbol.get(currency) || currency}
            {(item.prices?.[0] as EpayInventoryCost)?.amount}
          </Typography>
        )}
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          className={classes.description}
        >
          {(item.data as InventoryEpayItemData)?.shortDescription}
        </Typography>
      </div>
    </div>
  )

}